import React from 'react';

/*eslint-disable */

var externalIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("path", {
    d: "M13,0H7V2h4.59l-4,4H0v9H9V7.43l4-4V8h2V0ZM7,13H2V8H7Z"
  }));
});

export { externalIcon as default };
